import React from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import isNil from 'lodash/isNil';
import Checkbox from 'pages/Dashboard/components/Input/Checkbox';

type Props = {
  label?: string;
  onChange?: (checked: boolean) => void;
};

export default function RecurrenceCheckbox({
  label = 'Repeats Every',
  onChange,
}: Props) {
  const { watch, setValue } = useFormContext();
  const repeatType = watch('recurrence.repeatType');

  return (
    <Checkbox
      checked={!isNil(repeatType)}
      id="toggle-repeat"
      label={label}
      classes={{ label: '!font-semibold !text-gray-500' }}
      onChange={(checked) => {
        setValue('recurrence.repeatType', checked ? { id: 'daily', label: 'Day' } : undefined);
        setValue('recurrence.interval', checked ? 1 : undefined);
        setValue('recurrence.endsOn', undefined);
        setValue('recurrence.repeatsOn', undefined);
        onChange?.(checked);
      }}
    />
  );
}
